export const dashboardZhCN = {
  // shared — DashboardNav
  'dashboard.nav.ariaLabel': '仪表盘板块',
  'dashboard.nav.overview': '概览',
  'dashboard.nav.avatar': '头像',
  'dashboard.nav.coins': '金币',
  'dashboard.nav.contributions': '投稿',

  // shared — StatusBadge (contribution status)
  'dashboard.status.draft': '草稿',
  'dashboard.status.submitted': '已提交',
  'dashboard.status.communityReview': '社群评审',
  'dashboard.status.officialReview': '官方评审',
  'dashboard.status.approved': '已批准',
  'dashboard.status.rejected': '已拒绝',
  'dashboard.status.unknown': '未知',

  // shared — ClaimStatusBadge
  'dashboard.claimStatus.pending': '待审批',
  'dashboard.claimStatus.approved': '已批准',
  'dashboard.claimStatus.rejected': '已拒绝',

  // DashboardPage
  'dashboard.seo.title': '我的Grymwyrd',
  'dashboard.seo.description': '你的金币、地盘声明、投稿与角色，在永恒的暮光中。',
  'dashboard.displayNameFallback': '流浪者',
  'dashboard.welcomeBack': '欢迎归来',
  'dashboard.editAvatar': '编辑头像',
  'dashboard.loading': '正在汇总你的传奇…',
  'dashboard.avatarAlt': '{name}的肖像',
  'dashboard.offlineNotice':
    '实时档案数据不可用——显示你上次已知会话及示例内容。',

  // DashboardPage — Coins card
  'dashboard.coins.title': '坟冢金币',
  'dashboard.coins.viewAll': '查看全部',
  'dashboard.coins.unit': '金币',
  'dashboard.coins.noActivity': '暂无金币活动。',
  'dashboard.coins.fullHistory': '完整历史与购买金币',

  // DashboardPage — Contributions card
  'dashboard.contributions.title': '投稿',
  'dashboard.contributions.manage': '管理',
  'dashboard.contributions.empty': '暂无投稿——著笔你的第一篇。',

  // DashboardPage — Claims card
  'dashboard.claims.title': '占领的世界地点',
  'dashboard.claims.empty': '你在Grymwyrd尚未占领任何地盘。',
  'dashboard.claims.kindClaimed': '{kind}·占领于{date}',

  // DashboardPage — Characters card
  'dashboard.characters.title': '角色',
  'dashboard.characters.empty': '没有灵魂为你命名而绑定。',
  'dashboard.characters.level': 'Lv{level}',
  'dashboard.characters.unknown': '未知',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': '头像编辑器',
  'dashboard.avatarEditor.seo.description': '塑造你在Grymwyrd世界展现的容颜。',
  'dashboard.avatarEditor.heading': '头像编辑器',
  'dashboard.avatarEditor.errorNotImage': '该文件不是图像。',
  'dashboard.avatarEditor.errorNameRequired': '需要一个名字，即便在黑暗中。',
  'dashboard.avatarEditor.portrait': '肖像',
  'dashboard.avatarEditor.portraitPreview': '肖像预览',
  'dashboard.avatarEditor.avatarPreviewAlt': '头像预览',
  'dashboard.avatarEditor.zoom': '缩放',
  'dashboard.avatarEditor.zoomAria': '缩放肖像',
  'dashboard.avatarEditor.panHorizontal': '水平拖动肖像',
  'dashboard.avatarEditor.panVertical': '竖直拖动肖像',
  'dashboard.avatarEditor.uploadAria': '上传肖像图片',
  'dashboard.avatarEditor.changeImage': '更换图片',
  'dashboard.avatarEditor.uploadImage': '上传图片',
  'dashboard.avatarEditor.identity': '身份',
  'dashboard.avatarEditor.displayName': '显示名称',
  'dashboard.avatarEditor.backstory': '背景故事',
  'dashboard.avatarEditor.backstoryPlaceholder': '你从何而来，又将面临何种黑暗的命运？',
  'dashboard.avatarEditor.publicProfile': '公开档案',
  'dashboard.avatarEditor.publicVisible': '在传奇者殿堂中可见。',
  'dashboard.avatarEditor.publicHidden': '对其他流浪者隐藏。',
  'dashboard.avatarEditor.saving': '保存中…',
  'dashboard.avatarEditor.saveChanges': '保存更改',
  'dashboard.avatarEditor.saved': '已保存',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': '结账功能尚未开放——金库仍然紧闭。',
  'dashboard.coinHistory.notEnoughCoins': '金币不足。',
  'dashboard.coinHistory.reasonWorldClaim': '地盘占领',
  'dashboard.coinHistory.reasonCosmetic': '装饰',
  'dashboard.coinHistory.spendReason': '{category}——{name}',
  'dashboard.coinHistory.spentNotice': '在{name}上花费了{cost}枚金币。',
  'dashboard.coinHistory.seo.title': '坟冢金币',
  'dashboard.coinHistory.seo.description': '你的完整金币账本、充值与死者之物。',
  'dashboard.coinHistory.heading': '坟冢金币',
  'dashboard.coinHistory.balance': '余额',
  'dashboard.coinHistory.buyCoins': '购买金币',
  'dashboard.coinHistory.packCoins': '{coins}枚金币',
  'dashboard.coinHistory.packBonus': ' + {bonus}枚奖励',
  'dashboard.coinHistory.summoningCheckout': '正在召唤结账…',
  'dashboard.coinHistory.purchase': '购买',
  'dashboard.coinHistory.spendCoins': '花费金币',
  'dashboard.coinHistory.insufficientCoins': '金币不足',
  'dashboard.coinHistory.spending': '花费中…',
  'dashboard.coinHistory.spendAmount': '花费{cost}枚',
  'dashboard.coinHistory.historyTitle': '历史',
  'dashboard.coinHistory.tallyingLedger': '正在统计账本…',
  'dashboard.coinHistory.tableCaption': '金币交易历史',
  'dashboard.coinHistory.colReason': '原因',
  'dashboard.coinHistory.colAmount': '数量',
  'dashboard.coinHistory.noTransactions': '暂无交易。',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': '我的投稿',
  'dashboard.contributionsPage.seo.description':
    '你所著的传说，及其在审核者目光下的流转。',
  'dashboard.contributionsPage.heading': '投稿',
  'dashboard.contributionsPage.newContribution': '新增投稿',
  'dashboard.contributionsPage.loading': '正在展开你的卷轴…',
  'dashboard.contributionsPage.empty': '你尚未著笔任何传说。开始你的第一份投稿。',
  'dashboard.contributionsPage.untitledDraft': '无名草稿',
  'dashboard.contributionsPage.moderator': '审核者：',
  'dashboard.contributionsPage.entryFallback': '条目',
  'dashboard.contributionsPage.errorNameRequired': '每一件创作都需要一个名字。',
  'dashboard.contributionsPage.modalTitle': '新增投稿',
  'dashboard.contributionsPage.type': '类型',
  'dashboard.contributionsPage.titleLabel': '标题',
  'dashboard.contributionsPage.summaryLabel': '摘要',
  'dashboard.contributionsPage.saveDraft': '保存草稿',
  'dashboard.contributionsPage.submitting': '提交中…',
  'dashboard.contributionsPage.submitForReview': '提交审核',
}
